// extracted by mini-css-extract-plugin
export default {"dropWrapper":"DragAndDrop_dropWrapper__VY69w","dropContaner":"DragAndDrop_dropContaner__P-+Op","block":"DragAndDrop_block__lJ7mh","text":"DragAndDrop_text__-Qu24"};